import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { EdiSourceNode } from '../../../models/edi-viewer';

@Component({
  selector: 'lib-edi-source-tree-node',
  templateUrl: './edi-source-tree-node.component.html',
  styleUrls: ['./edi-source-tree-node.component.scss'],
  standalone: false
})
export class EdiSourceTreeNodeComponent implements OnChanges, OnInit, AfterViewInit {
  @Input() node: EdiSourceNode;
  @Input() depth = 0;
  @Input() expandedNodeIds: ReadonlySet<string> = new Set<string>();
  @Input() selectedNodeIds: ReadonlySet<string> = new Set<string>();
  @Input() scrollTargetId?: string;
  @Output() sourceSelected = new EventEmitter<string[]>();

  expanded = false;

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  get selected(): boolean {
    return this.selectedNodeIds.has(this.node.id);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.node && this.expandedNodeIds.has(this.node.id)) this.expanded = true;
    if (changes.scrollTargetId && !changes.scrollTargetId.firstChange) this.scrollIntoViewIfTargeted();
  }

  ngOnInit(): void {
    this.expanded = this.expanded || this.depth < 2 || this.expandedNodeIds.has(this.node.id);
  }

  ngAfterViewInit(): void {
    this.scrollIntoViewIfTargeted();
  }

  toggle(): void {
    if (this.node.children?.length) this.expanded = !this.expanded;
    else this.sourceSelected.emit([this.node.id]);
  }

  private scrollIntoViewIfTargeted(): void {
    if (!this.node || this.scrollTargetId !== this.node.id) return;
    setTimeout(() => {
      this.elementRef.nativeElement.querySelector<HTMLElement>('.node-row')?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
    });
  }
}
